import { AddLayerObject } from 'maplibre-gl';

import { ISelectOption } from '../components/common/input/select/select';
import { WaterLayerState } from '../utils/withinStateGeometry';

export enum CaliWaterTiles {
  WATER_DISTRICTS = 'california-water-districts2',
  SGMA = 'california-sgma',
  GSA = 'california-gsa',
  ADJUDICATED_BASINS = 'california-adjudicated-basins',
}

export enum NebraskaWaterTiles {
  NEBRASKA_NRD = 'nebraska-nrd',
}

export type WaterModalContent = {
  moreInfo: {
    description?: string;
  };
  title: string;
};

export type WaterLayer = WaterModalContent & {
  /** "This is the main layer" - Luke Brandon */
  layer: AddLayerObject;
  outlineLayer: AddLayerObject;
  enabled: boolean;
  defaultOpacity: number;
  hoverOpacity: number;
  enableCheckBoxHover: boolean;
};

// Extending ISelectOption ensures that we can put it into the Select component
export type WaterState = ISelectOption & {
  label: WaterLayerState;
  layers: WaterLayer[];
  icon: any;
  moreInfo: {
    mainText: string;
    sourceText: string;
  };
  modalTabs?: WaterModalContent[];
  /** The layer the mouse is over */
  hoveredLayer?: AddLayerObject;
  /** The layer that reacts when hovered */
  hoveredResultLayer?: AddLayerObject;
  /** The property key of the hovered feature from the tiles that will display in the tooltip */
  hoveredTooltipPropertyKey?: string;
};

export type CaWaterDistrictsProperties = {
  OBJECTID: number;
  AGENCYNAME: string;
  Shape_Area: number; // Square footage of water district
  Acreage: number;
};

export type CaSGMAPriorityProperties = {
  OBJECTID: number;
  Basin_Name: string; // Basin Name
  Basin_Numb: string; // Basin Name
  Basin_Su_1: string; // Sub basin name
  Basin_Subb: string; // Sub basin number
  Priority: string;
};

export type CaGSAProperties = {
  OBJECTID: number;
  Basin: string;
  GSA_ID: string;
  GSA_Name: string;
  GSA_URL: string;
  POC_Email: string;
  POC_Name: string;
  POC_Phone: string;
};

export type CaAdjudicatedBasinProperties = {
  ADJUDICATI: string;
  NAME: string;
  Label: string;
  OBJECTID_1: number;
  WATERMASTE: string;
  COMMENTS: string;
};
